module.exports = {
  context: {
    count: 1
  },
  variants: [
    {
      name: 'Count 2',
      context: {
        count: 2
      }
    },
    {
      name: 'Count 3',
      context: {
        count: 3
      }
    },
    {
      name: 'Count 4',
      context: {
        count: 4
      }
    }
  ]
}
